import axiosClient from '../../api/axiosClient';

export const chatMessagesService = {
  async fetchChatMessages(payload) {
    return await axiosClient.post('api/conversations/get-messages', payload, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },
  async fetchChatMessageById(chatId, messageId) {
    return await axiosClient.get(`api/conversations/${chatId}/messages/${messageId}`, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },
  async toggleReaction(chatId, messageId, reactedBy, reactionType) {
    return await axiosClient.post(
      `api/conversations/${chatId}/messages/${messageId}/reactions`,
      {
        userId: reactedBy,
        reactionType: reactionType,
      },
      {
        baseURL: process.env.REACT_APP_SOCKET_API_KEY,
      }
    );
  },
  async sendMessage(payload) {
    const trimmedContent = typeof payload.content === 'string' ? payload.content.trim() : payload.content;

    const normalizedPayload =
      typeof payload.content === 'string'
        ? {
            ...payload,
            content: trimmedContent,
          }
        : payload;

    return await axiosClient.postForm(`api/conversations/${normalizedPayload.chatId}/send-message`, normalizedPayload, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },
  async fetchChatParticipants(chatId) {
    return await axiosClient.get(`/api/conversations/${chatId}/chat-participants`, {
      baseURL: process.env.REACT_APP_SOCKET_API_KEY,
    });
  },
};
